/**
 * Created by RSchweber-Koren on 4/10/2017.
 */

import angular from "angular";

import Assert from "tbAssert";
import MakePropsEnumerable from "../../utility/MakePropsEnumerable";
import TbAppConfig from "./TbAppConfig";

const mCurrentTbAppConfig = new WeakMap();

class TbAppConfigDataServiceProvider {
    constructor() {
        mCurrentTbAppConfig.set(this, null);
    }

    init(appConfigData) {
        const currentAppConfig = mCurrentTbAppConfig.get(this);
        if (currentAppConfig instanceof TbAppConfig) {
            throw new Error("Tb App Config Data Service Error: Attempt to re-initialize app configuration.");
        }

        Assert.StrictAssert((appConfigData != null), "Missing configuration data");

        if (appConfigData instanceof TbAppConfig) {
            mCurrentTbAppConfig.set(this, appConfigData);
        }
        else {
            let config = new TbAppConfig(appConfigData);

            Assert.StrictAssert((config instanceof TbAppConfig), "Invalid configuration data");
            mCurrentTbAppConfig.set(this, config);
        }
    }

    get appConfig() {
        const currentAppConfig = mCurrentTbAppConfig.get(this);

        if (currentAppConfig == null) {
            throw new Error("Tb App Config Service Not Configured Before Use");
        }

        Assert.StrictAssert(currentAppConfig instanceof TbAppConfig, "Tb App Config Service data has wrong type");

        return currentAppConfig;
    }

    get $get() {
        return () => mCurrentTbAppConfig.get(this);
    }
}

MakePropsEnumerable(TbAppConfigDataServiceProvider.prototype, [
   "appConfig",
   "$get"
]);

export default angular
    .module("trackerbase-app.config.tb-app-config",[])
    .provider("TbAppConfigDataService", TbAppConfigDataServiceProvider)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/config/tb-app-config/TbAppConfigDataService.js
// module id = IX+G
// module chunks = 1